import * as React from 'react';
import AfrDataImportCore from '../AfrCore/AfrDataImportCore';




const AfrDataImportA = (props: any) => {

    return (
        <React.Fragment>
            <AfrDataImportCore userRole="ADMIN"  />
        </React.Fragment>
    );
}

export default AfrDataImportA;